import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Pricing({ plans }) {
  const navigate = useNavigate();

  const [subscriptionData, setSubscriptionData] = useState({
    plan: "",
    price: 0,
    planID: "",
    duration: 0,
  });

  const subscriptionPlans = [
    {
      plan: "Basic",
      price: 30,
      planID: "price_1PLrp2DPGZKo4YmHvV1DHZNY",
      duration: 1,
      features: [
        "1 Month Access",
        "AI-Powered Learning",
        "AI-Assisted Modules",
        "Unlimited Mock",
      ],
      savings: "Save 10%",
      additionalDetails: "Billed $30 for 1 month, renews monthly",
      promotion: "2 Months FREE",
      cancelledMRP: "$240",
    },
    {
      plan: "Premium",
      price: 15,
      planID: "price_1PLrtNDPGZKo4YmHNBxK2InW",
      duration: 4,
      features: [
        "6 Months Access",
        "AI-Powered Learning",
        "AI-Assisted Modules",
        "Unlimited Mock",
      ],
      savings: "Save 61%",
      additionalDetails: "Billed $90 for 6 months, renews half-yearly",
      promotion: "2 Months FREE",
      cancelledMRP: "$120",
    },
    {
      plan: "Starter",
      price: 20,
      planID: "price_1PLrrLDPGZKo4YmHgnCAdQJd",
      duration: 2,
      features: [
        "3 Months Access",
        "AI-Powered Learning",
        "AI-Assisted Modules",
        "Unlimited Mock",
      ],
      savings: "Save 25%",
      additionalDetails: "Billed $60 for 3 months, renews quarterly",
      promotion: "1 Months FREE",
      cancelledMRP: "$180",
    },
  ];

  console.log("plans", plans);

  const handleSubscriptionSelection = (selectedPlan) => {
    setSubscriptionData(selectedPlan);
    navigate("/checkout", {
      state: { subscriptionData: { ...selectedPlan } },
    });
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 bg-slate-50">
      <h1 className="text-center text-3xl font-bold text-gray-900 mb-10">
        Choose Your Plan
      </h1>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 lg:gap-12">
        {plans.length > 0 ? (
          plans.map((plan, index) => (
            <div
              key={index}
              className={`rounded-lg shadow-md p-6 ${
                plan.plan === "Premium"
                  ? "bg-white border border-fuchsia-900 text-gray-900 scale-105"
                  : "bg-white text-gray-900"
              } w-full max-w-sm mx-auto`}
            >
              <div className="flex items-center justify-center mb-4">
                <svg
                  className={`w-5 h-5 ${
                    plan.plan === "Premium"
                      ? "text-fuchsia-900"
                      : "text-gray-500"
                  } mr-2`}
                  viewBox="0 -2 10 14"
                  fill="currentColor"
                >
                  <path d="M8.81738 2.82614C8.7659 2.77466..." />
                </svg>
                <p
                  className={`text-sm font-bold ${
                    plan.plan === "Premium"
                      ? "text-fuchsia-900"
                      : "text-gray-800"
                  }`}
                >
                  {plan.title === "Premium" ? "Most Popular" : "Popular"}
                </p>
              </div>
              <div className="flex justify-between items-center mb-4">
                <div>
                  <div className="flex justify-between items-center mb-4">
                    <p className="text-lg font-semibold">
                      {plan.duration} Months
                    </p>
                    {plan.title !== "Basic" && (
                      <p className="text-md text-fuchsia-600 font-bold ml-4">
                        + {plan.promotion}
                      </p>
                    )}
                  </div>
                </div>
                <p className="text-sm font-semibold bg-gray-200 text-gray-900 rounded-full px-4 py-1">
                  Save {plan.savings}%
                </p>
              </div>
              <div className="my-4">
                <div className="flex items-baseline">
                  <span className="text-3xl font-bold">${plan.price}</span>
                  <span className="text-sm ml-1">/mo</span>
                  <p className="text-xl text-center text-gray-500 m-2">
                    <span className="line-through text-gray-400">
                      {plan.cancelledMRP}
                    </span>
                  </p>
                </div>
                <p
                  className={`text-sm font-light ${
                    plan.title === "Premium" ? "text-gray-700" : "text-gray-500"
                  }`}
                >
                  {plan.additionalDetails}
                </p>
              </div>
              <ul className="mt-6 space-y-3">
                {plan.features.map((feature, featureIndex) => (
                  <li
                    key={featureIndex}
                    className="flex items-center gap-2 text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="h-5 w-5 text-indigo-600"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                className={`mt-8 block w-full rounded-lg px-6 py-3 text-sm font-medium text-center transition-all duration-200 focus:outline-none focus:ring ${
                  plan.plan === "Premium"
                    ? "bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 text-white hover:opacity-90"
                    : "bg-white text-fuchsia-800 border border-fuchsia-900 hover:bg-gradient-to-r hover:from-fuchsia-900 hover:to-fuchsia-700 hover:text-white hover:opacity-100"
                }`}
                onClick={() => handleSubscriptionSelection(plan)}
              >
                {plan.plan === "Premium"
                  ? "Get Special Deal"
                  : `${plan.duration} Month Subscription`}
              </button>
              <p className="text-xs text-center mt-2 text-gray-500">
                Powered By PrepNexis Ai
              </p>
            </div>
          ))
        ) : (
          <p>No plans available</p>
        )}
      </div>
    </div>
  );
}
